import React from 'react'
import Navbar from '../Nav/NavBar';

const Header = (props) => {
    return <Navbar />;
}

export default Header;